<template>
<div class="backdrop" v-bind:class="[showPanel ? 'd-block' : 'd-none',classstyle]" @click="requestDismiss()">
    <div class="wrapper-panel" v-bind:class="[showPanel ? 'd-block' : 'd-none' , activePanel ? 'active' : ''  , placement ]">
        <div class="inner-panel" @click="stopPropagation($event)">
            <header>
                <slot name="header"></slot>
            </header>
             <main>
                <slot></slot>
            </main>
            <footer>
                <slot name="footer"></slot>
            </footer>
        </div>
    </div>
</div>

</template>

<script>
    export default {
        props: {
            classstyle: { default: function () { return ''; }},
            placement: {
                default: function () {
                    return 'right';
                }
            },
            dismissible: {
                default: function () {
                    return true;
                }
            } 
        },
        data: function(){
            return {
                time:100, /* ms */
                showPanel:false,
                activePanel:false
            }
        },
        computed: {
            
        },
        watch: { 
           
        },
        mounted(){
        },
        methods: {
            stopPropagation(ev) {
                ev.stopPropagation();
            },
            hide() {
                this.activePanel = false;
                this.$emit("afterHide", {
                        el:this
                });
                setTimeout(() => {
                    this.showPanel = false;
                    this.$emit("onHide", {
                        el:this
                    });
                }, this.time);
            },
            show() {
                this.showPanel = true;
                this.$emit("afterShow", {
                        el:this
                });
                setTimeout(() => {
                    this.activePanel = true;
                    this.$emit("onShow", {
                        el:this
                    });
                }, this.time);
            },
            requestDismiss() {
                if (!this.dismissible) return;
                return this.hide();
            }
            
        }
    }
</script>
<style lang="scss" scoped>

    .backdrop {
        position:fixed;
        top :0px;
        left :0px;
        width:100%;
        height :100%;
        z-index: 1050;
        background-color : rgba(0,0,0,0.6);
        .wrapper-panel {
            position: absolute;
            height :100%;
            width:600px;
            max-width :90%;
            background-color:#fff;
            transition: all .6s;
            opacity: 0;
            border :1px solid #ccc;
            &.right {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
                right :0;
                top: 0;
                transform : translateX(100%);
            }
            &.left {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
                left: 0;
                top: 0;
                transform : translateX(-100%);
            }
            &.bottom {
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                left: 0;
                top: 0;
                transform : translateY(100%);
            }
            &.top {
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
                left: 0;
                bottom: 0;
                transform : translateY(-100%);
            }
            &.active {
                opacity: 1;
                transform : translateY(0)!important;
                transform : translateX(0)!important;
            }
            .inner-panel {
                position :relative;
                display:flex;
                height :100%;
                width :100%;
                padding :10px;
                flex-direction :column;

                header {
                    height: auto;
                }

                main {
                    flex: auto;
                    overflow-y :auto;
                    padding :10px 0px;
                }

                footer {
                    height: auto;
                }
            }
        }
    }
</style>